<template>
  <div>
    <div class="video sxt-video">
      <!-- 主持人 -->
      <!-- <div id="f_ocx2" :class="activeVideo == 2 ? 'active' : ''">
        <iframe
          name="myiframe"
          id="ocx2"
          :src="cdbm"
          frameborder="0"
          align="middle"
          width="100%"
          height="100%"
          scrolling="no"
        ></iframe>
      </div> -->
      <!--  -->
      <div id="f_ocx2" :class="activeVideo == 2 ? 'active' : ''">
        <sxt class="video" :bdId="bdId" @send="send" ref="sharePlayer"></sxt>
      </div>
      <div id="f_ocx" :class="activeVideo == 1 ? 'active' : ''"></div>
    </div>
    <div class="videoBtns">
      <button
        v-for="(item, index) in btns"
        :key="index"
        :class="activeBtn == item.id ? 'active' : ''"
        type="button"
        @click="changeVideo(item.id)"
      >
        {{ item.text }}
      </button>
    </div>
  </div>
</template>
<script>
import sxt from "./sxt.vue";
export default {
  name: "myVideo",
  components: {
    sxt,
  },
  props: {
    bdId: {
      type: String,
    },
  },
  data() {
    return {
      btns: [],
      activeBtn: "999",
      activeVideo: 2,
      currentParentId: "8",
      cdbm: "",
      isLoad: false,
      kbxmZt: sessionStorage.getItem("kbxmZt")
        ? sessionStorage.getItem("kbxmZt")
        : "",
    };
  },
  methods: {
    send(data) {
      this.$emit("send", data);
    },
    changeVideo(id) {
      this.activeBtn = id;
      if (id != "999") {
        this.activeVideo = 1;
        if (!this.isLoad) {
          initOcx(this.currentParentId, id);
          this.isLoad = true;
        } else {
          RealPlay(id);
        }
      } else {
        this.activeVideo = 2;
      }
    },
    //获取摄像头参数
    getSxt() {
      this.btns = [];
      this.$api
        .getSxtAndLive(this.bdId)
        .then((res) => {
          if (res.data.success) {
            const { sxtInfo } = res.data.data;
            if (sxtInfo.sxtdz) {
              let sxtdz = sxtInfo.sxtdz.split(",");
              this.btns.push({ text: "主持人桌面", id: "999", url: sxtdz[0] });
            }
            sxtInfo.sxtbh.forEach((obj, index) => {
              this.btns.push({ text: "现场监控" + (index + 1), id: obj });
            });
            this.currentParentId = sxtInfo.sxtdz;
          }
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getSxt();
  },
};
var agent = navigator.userAgent.toLowerCase();
var g_ocx;
var PLUGINS_CLASSID = "5B709BF0-B3BB-4287-8107-B40D88394F48";
var VERSION_GUI = "version=3,1,0,4";
var Sys = {};
var isMac = navigator.userAgent.toLowerCase().indexOf("mac") != -1;
var ua = navigator.userAgent.toLowerCase();
var s;
(s = ua.match(/(msie\s|trident.*rv:)([\d.]+)/))
  ? (Sys.ie = s[2])
  : (s = ua.match(/firefox\/([\d.]+)/))
  ? (Sys.firefox = s[1])
  : (s = ua.match(/chrome\/([\d.]+)/))
  ? (Sys.chrome = s[1])
  : (s = ua.match(/opera.([\d.]+)/))
  ? (Sys.opera = s[1])
  : (s = ua.match(/version\/([\d.]+).*safari/))
  ? (Sys.safari = s[1])
  : 0;
var PLUGINS_NAME = "WebActiveEXE.Plugin.DH.1";

var hasPlugin;

var g_PlayTime;
var g_curSpeed = 4; //默认的正常速度
var htmlStChn1 = "";
var mainOcxHtml = "";
var handlerOcxEvents;
var parentIdJson = {
  "010BAA889C814CBAA47AF1E3333DFED0": {
    jkurl: "ztx2016.f3322.net",
    jkus: "jdpt",
    jkps: "chensw@123",
    port: 38888,
  }, //账号密码不对
  A5F5DF8F343343A68C74FD960FCF8987: {
    jkurl: "220.185.141.30",
    jkus: "admin",
    jkps: "ztx0380@",
    port: 38888,
  }, //可以登录
  "0000": {
    jkurl: "zhaotx.dns0755.net",
    jkus: "admin",
    jkps: "ztx0380@",
    port: 48888,
  }, //椒江摄像头
  "73a3d274db3e426895c5405a6cc6c9da": {
    jkurl: "220.185.154.178",
    jkus: "admin",
    jkps: "admin123",
    port: 38888,
  }, //路桥摄像头
  ahsxtdz1: {
    jkurl: "183.162.254.54",
    jkus: "admin",
    jkps: "ahztx123456",
    port: 58899,
  }, //合肥摄像头
  ahsxtdz2: {
    jkurl: "183.162.254.54",
    jkus: "admin",
    jkps: "ahztx123456",
    port: 58899,
  }, //合肥摄像头
  ztxllkbs001: {
    jkurl: "101.68.69.10",
    jkus: "admin",
    jkps: "ztx12345",
    port: 58899,
  }, //西溪新座6楼摄像头
};
function initOcx(id, id2) {
  hasPlugin = checkPlugins();
  if (Sys.ie) {
    mainOcxHtml =
      '<object id="ocx" style="top:-150px; left:-150px;" classid="CLSID:{' +
      PLUGINS_CLASSID +
      '}" codebase="/webrec.cab"></object>';
  } else {
    mainOcxHtml =
      '<object id="ocx" width="100%" height="100%"  type="application/media-plugin-version-3.1.0.2" VideoWindTextColor="9c9c9c" VideoWindBarColor="414141"></object>';
  }

  var recInfosByFile = [];
  handlerOcxEvents = {
    fireOcxEvent: function (jsonStr) {},
    InsertNetRecordFileInfo: function (nChannel, nEnd, strRecordInfo) {
      var htmlRecordInfo = "";
      var recInfo = [];
      if (strRecordInfo != "") {
        recInfo = strRecordInfo.split(":");
        var num = recInfo.length;
        for (var i = 0; i < num; i++) {
          if (recInfo[i] == "") {
            continue;
          }
          htmlRecordInfo +=
            '<li><a id="StChn' +
            i +
            '">' +
            "channel: " +
            nChannel +
            " info: " +
            recInfo[i] +
            "</a></li>";
        }
        //2016011120372620160111203741-04-13824-0-00-00-00-19527-00-00
        //录像时间-录像类型-文件大小-文件索引-码流类型-...
        document.getElementById("RecInfo").style.display = "";
        document.getElementById("DwonLoadPos").style.display = "";
        document.getElementById("RecInfoList").innerHTML = htmlRecordInfo;
        handlerOcxEvents.editRecordFileInfo(recInfo);
      }
    },
    editRecordFileInfo: function (recInfo) {
      var index = 0;
      for (var i = 0; i < recInfo.length; i++) {
        var tmpInfo = recInfo[i];
        if (tmpInfo == "") continue;
        var recArry = tmpInfo.split("-");
        //原始的文件结构信息(下载文件结构不同)：
        //2014102216001120141022160011- 04 - 279  -  53   - 00    -01
        //2013041109102020130411100000-type1-size2-nIndex3-stream4-nRecChannel5-nDriveNo6-nStartCluster7
        //下载的时候需要传给控件的结构信息：
        //开始时间结束时间-type-channel-stream-文件大小2- 磁盘3-起始簇号4
        var infoAttach =
          recArry[0] +
          "-" +
          recArry[1] +
          "-" +
          recArry[5] +
          "-" +
          recArry[4] +
          (recArry[6] == undefined
            ? ""
            : "-" + recArry[2] + "-" + recArry[6] + "-" + recArry[7]);

        if (contains(recInfosByFile, infoAttach)) {
          continue;
        }
        recInfosByFile[index] = infoAttach;
        index++;
      }
      //alert(recInfosByFile.join(':'));
    },
  };
  loadPlugins(id, id2);
}

/**
 * 检测浏览器是否存在视频插件
 * @return {Boolean}
 */
function checkPlugins() {
  var result;
  if (Sys.ie) {
    try {
      result = new ActiveXObject(PLUGINS_NAME);
      //delete result;
    } catch (e) {
      return false;
    }
    return true;
  } else {
    navigator.plugins.refresh(false);
    result = navigator.mimeTypes["application/media-plugin-version-3.1.0.2"];
    return !!(result && result.enabledPlugin);
  }
}

function contains(arr, obj) {
  var i = arr.length;
  while (i--) {
    if (arr[i] == obj) {
      return true;
    }
  }
  return false;
}

function loadPlugins(id, id2) {
  if (checkPlugins()) {
    hasPlugin = true;
    setTimeout(function () {
      loadPageOcx(id, id2);
    }, 2000);
  } else {
    window.location.href = "/视频插件.zip";
  }
}

function loadPageOcx(id, id2) {
  if (document.getElementById("f_ocx")) {
    document.getElementById("f_ocx").innerHTML = mainOcxHtml;
    initPageOcx(id, id2);
  }
}

function initPageOcx(id, id2) {
  g_ocx = document.getElementById("ocx");
  g_ocx.AddEventListener("SetNetPlayFileInfo", ShowRecInfo);
  g_ocx.AddEventListener("NetPlayTimeInform", ShowPlayTime);
  g_ocx.AddEventListener("TransEvent", handlerOcxEvents.fireOcxEvent);

  // 按钮隐藏可以自由选择怎么设置，遵从此协议格式即可 "Snapshot": true 监视播放窗口上的工具条会显示抓图按钮
  var str =
    '{"Protocol":"VideoFuncProtocol","Params":{"Audio":true, "Snapshot": true, "Record": false, "ZoomIn":true}}';
  g_ocx.ProtocolPluginWithWebCall(str);

  //  "IsPlayBackCanSnapshot": true 回放时播放窗口上的工具条会显示抓图按钮
  str = '{"IsPlayBackCanSnapshot": true}';
  g_ocx.SetInitParams(str);

  // 工具条抓图按钮点击后，图片保存路径
  g_ocx.SetConfigPath(1, "C:\\PictureDownload");
  //g_ocx.OnFullScreenClk();

  var jsonData = parentIdJson[id];
  LoginDevice(jsonData.jkurl, jsonData.jkus, jsonData.jkps, jsonData.port);
  console.log(jsonData);
  console.log(id2);
  RealPlay(id2);
}

function RealPlay(channel) {
  g_ocx.SetModuleMode(1); //监视模式
  g_ocx.ConnectRealVideo(Number(channel), 1);
}

function ControlPtz() {
  g_ocx.ControlPtzEx(0, 1, 1, 8, 1, 0);
}

function LoginDevice(jkurl, jkus, jkps, port) {
  var bRet = g_ocx.LoginDeviceEx(jkurl, port, jkus, jkps, 0);
  console.log(bRet);
  g_ocx.SetWinBindedChannel(1, 0, 0, 0);
  if (bRet == 0) {
    /*此协议字段说明：
		Protocol 表示和控件交互的协议名 目前控件支持的交互协议具体见文档，这里的QueryDevCfgInfo表示需要查询设备的配置信息
		Params 字段表示查询的配置参数：
			Command 表示向设备查询的配置名称 cameraConnectState 表示前端连接状态
			Channel 表示查询的通道号
		*/
    var strRet = g_ocx.ProtocolPluginWithWebCall(
      '{"Protocol":"QueryDevCfgInfo", "Params":{"Command":"CameraConnectState","Channel":0}}'
    );
  }
}

function LogoutDevice() {
  g_ocx.LogoutDevice();
}

function LocalPlay() {
  g_ocx.QuickOperation(0);
}

function CapturePicture() {
  g_ocx.CapturePic(0, "c:\\test", "123", 1);
}

function DownloadByTime() {
  var str = '{"Protocol":"QueryDownloadByTimeInfo", "Params":{}}';
  var ret = g_ocx.DownloadByTime(
    0,
    "2016-03-23 00:03:00",
    "2016-03-23 00:06:00",
    "C:\\test",
    "123.mp4"
  );
  alert(ret);
  if (ret == 0) {
    var time = 5000;
    while (time > 0) {
      Sleep(100);
      time = time - 100;
      var info = g_ocx.ProtocolPluginWithWebCall(str);
      document.getElementById("DwonLoadInfo").value = info;
    }
  }
}

function Sleep(n) {
  var start = new Date().getTime();
  while (true) {
    if (new Date().getTime() - start > n) {
      break;
    }
  }
}

function GetAllChannelInfo() {
  var data = g_ocx.GetAllChannelInfo();
}

function LocalRecord() {
  var ret = g_ocx.LocalRecord(0);
  alert(ret);
}

function StopPlay() {
  g_ocx.DisConnectRealVideo(2);
}

function FullScreen() {
  g_ocx.OnFullScreenClk();
}

function QueryRecord() {
  g_ocx.SetModuleMode(4); //回放模式
  g_ocx.SetWinBindedChannel(4, 0, 0, 4);
  g_ocx.SwitchMonth(2016, 4, 20);
  g_ocx.SwitchDay(2016, 4, 20);
  htmlStChn1 = "";
}

function PlayBack() {
  //ocx.SetSearchBeginTime('2014-10-13 00:00:00',true);
  //	g_ocx.PlayBackByTime(0, '01:00:00');
  var tmp =
    '{"Channel":1,"StartTime":"2016-04-20 03:29:40","EndTime":"2016-04-20 03:29:59"}';
  g_ocx.PlayBackByRecordFile(tmp);
}

function FastPlay() {
  if (g_curSpeed >= 8) {
    //达到最大速度以后再快放就回到正常速度,客户可以按照自己的意愿来处理此时是否灰显快放按钮
    g_curSpeed = 4;
  } else {
    g_curSpeed++;
  }
  ocx.SpeedPlayBack(g_curSpeed);
}

function SlowPlay() {
  if (g_curSpeed <= 0) {
    //达到最小速度以后再慢放就回到正常速度,客户可以按照自己的意愿来处理此时是否灰显快放按钮
    g_curSpeed = 4;
  } else {
    g_curSpeed--;
  }
  ocx.SpeedPlayBack(g_curSpeed);
}

function Download() {
  g_ocx.DownloadRecordByTime(
    1,
    "2016-04-18 00:00:00",
    "2016-04-18 00:10:00",
    "C:\\RecordDownload",
    "dav"
  );
}

function PlayRec() {
  g_ocx.PlayBack();
}

function PauseRec() {
  g_ocx.PausePlayBack();
}

function ShowPlayTime(time) {
  //时间的格式00020018|  |是通道分隔符
  g_PlayTime = time;
  document.getElementById("playtime").value = g_PlayTime;
}

function ShowRecInfo(nCh, strRecodInfo) {
  document.getElementById("PlayBack").style.display = "";
  document.getElementById("PlayRec").style.display = "";
  document.getElementById("PauseRec").style.display = "";
  document.getElementById("FastPlay").style.display = "";
  document.getElementById("SlowPlay").style.display = "";
  document.getElementById("download").style.display = "";
  document.getElementById("RecInfo").style.display = "";
  document.getElementById("ShowPlayTime").style.display = "";
  document.getElementById("DwonLoadPos").style.display = "";
  g_PlayTime = "";
  var readtime = strRecodInfo.split(":");
  var num = readtime.length;
  for (var i = 0; i < num; i++) {
    if (readtime[i] == "") continue;
    htmlStChn1 +=
      '<li><a id="StChn' +
      i +
      '">' +
      "channel: " +
      nCh +
      " info: " +
      readtime[i] +
      "</a></li>";
  }
  document.getElementById("RecInfoList").innerHTML = htmlStChn1;
}
</script>
<style lang="less">
.video {
  width: 100%;
  height: 270px;
  background: #333;
  position: relative;
  #f_ocx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
  }
  #f_ocx.active {
    visibility: initial;
  }
  #f_ocx2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    //visibility: hidden;
  }
  #f_ocx2.active {
    visibility: initial;
  }
}
.videoBtns {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  button {
    height: 45px;
    line-height: 45px;
    background: #404040;
    color: #fff;
    font-size: 16px;
    width: 100%;
    padding: 0 10px;
  }
  .btn_div {
    border: 1px solid red;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  button.active {
    background: @base-color;
    font-weight: bold;
  }
}
</style>
